module.exports = function() {
  return new Worker(__webpack_public_path__ + "ff41cabfb8bba92e2f72.worker.js");
};